import { useState } from "react";
import { Heading, Text, Button } from "@radix-ui/themes";
import { FiEdit2 } from "react-icons/fi";
import { panelTokens } from "@/lib/tokens";

const MAX_PREVIEW_LENGTH = 300;

type AboutSectionProps = {
  text: string;
  onAddBio?: () => void;
  canEdit?: boolean;
  artistColor?: string;
};

export function AboutSection({
  text,
  onAddBio,
  canEdit = false,
  artistColor,
}: AboutSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isTruncated = text.length > MAX_PREVIEW_LENGTH;
  const displayText =
    isTruncated && !isExpanded
      ? `${text.slice(0, MAX_PREVIEW_LENGTH).trim()}...`
      : text;

  return (
    <div>
      <Heading
        as="h3"
        size="2"
        className={`${panelTokens.heading} text-sm font-semibold leading-[140%]`}
        style={artistColor ? { color: artistColor } : { color: "#050C2B" }}
      >
        About the Artist
      </Heading>

      {text ? (
        <Text
          as="p"
          className="text-[#525966] text-sm font-normal leading-[140%]"
        >
          {displayText}
          {isTruncated && (
            <>
              {" "}
              <button
                type="button"
                onClick={() => setIsExpanded((prev) => !prev)}
                className="font-medium hover:underline"
                style={
                  artistColor ? { color: artistColor } : { color: "#3042E2" }
                }
              >
                {isExpanded ? "show less" : "show more"}
              </button>
            </>
          )}
        </Text>
      ) : canEdit ? (
        <Button
          variant="ghost"
          onClick={onAddBio}
          className="font-['Open_Sans'] text-[14px] text-slate-700 hover:text-black flex items-center gap-2"
        >
          <FiEdit2 className="w-3 h-3" />
          <span>Add Bio</span>
        </Button>
      ) : (
        <Text className="font-['Open_Sans'] text-[14px] text-slate-500">
          No bio provided.
        </Text>
      )}
    </div>
  );
}

export default AboutSection;
